import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

export function Radio(props) {
  const id = props.id ? props.id : _.uniqueId('radio-');

  return (
    <div
      className={props.className}
      data-checked={props.checked}
    >
      <label htmlFor={id}>
        <input
          type="radio"
          name={props.name}
          id={id}
          value={props.value}
          checked={props.checked}
          disabled={props.disabled}
          onChange={props.onChange}
          aria-checked={props.checked}
          aria-disabled={props.disabled}
        />
        {props.children}
      </label>
    </div>
  );
}

Radio.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

Radio.defaultProps = {
  checked: false,
  disabled: false,
  children: null,
  className: 'radio',
  id: null,
  name: null,
};
